import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useGetAllRolesQuery } from 'services/roles/roles.api';
import { selectUsername } from 'store/selectors/User/userSelectors';
import type { Role } from '../types/UserTable.types';
import { buildRoleHierarchy } from '../utils/userTable.utils';

export interface RoleHierarchyResult {
  allRoles: Role[];
  hierarchy: Record<string, number>;
  yourHighestRoleHierarchyId: number;
}

/**
 * Fetches all roles and computes the role→hierarchy map plus the current
 * user's highest-privilege hierarchy level.
 */
export function useRoleHierarchy(): RoleHierarchyResult {
  const username = useSelector(selectUsername);
  const { data: allRoles = [] } = useGetAllRolesQuery(undefined);

  const { hierarchy, yourHighestRoleHierarchyId } = useMemo(
    () => buildRoleHierarchy(allRoles, username),
    [allRoles, username],
  );

  return { allRoles, hierarchy, yourHighestRoleHierarchyId };
}
